import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import filterdropdown from "../../assets/images/filterdropdown.png"

const DropdownFilter = ({ onApply, selectedFilters, setSelectedFilters }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;

  // Mapping for display → value in array
  const orderTypeMap = {
    Custom: "custom_order",
    Reserve: "reserve",
    Repair: "repair_order",
  };

  const orderTypes = Object.keys(orderTypeMap);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (type) => {
    const mappedValue = orderTypeMap[type]; // map display label to backend value

    setSelectedFilters((prev) =>
      prev.includes(mappedValue)
        ? prev.filter((f) => f !== mappedValue)
        : [...prev, mappedValue]
    );
  };

  const handleSelectAll = () => {
    const allValues = Object.values(orderTypeMap);
    setSelectedFilters((prev) =>
      prev.length === allValues.length ? [] : allValues
    );
  };

  const handleClear = () => setSelectedFilters([]);

  const handleApply = () => {
    onApply();
    setIsOpen(false);
  };

  // Close when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-filter" ref={dropdownRef}>
      {/* Three-line filter button */}
      <button onClick={toggleDropdown} className="filter-icon-btn">
        <img src={filterdropdown} alt="filterimg" />
      </button>

      {isOpen && (
        <div className="pos-dropdown-menu" style={{ display: "block" }}>
          {/* Header */}
          <div>
            <span
              style={{
                color: "#1D1D1F",
                fontSize: "16px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              Filter
            </span>
          </div>
          <div
            style={{ borderBottom: "1px solid #E8E8ED", margin: "10px 0px" }}
          ></div>

          <div className="dropdown-header1">
            <span className="active-filters">
              {t("Active Filters")} ({selectedFilters.length})
            </span>
            <button onClick={handleClear} className="clear-btn">
              {t("Clear all")}
            </button>
          </div>
          <div
            style={{ borderBottom: "1px solid #E8E8ED", margin: "10px 0px" }}
          ></div>

          {/* Options */}
          <div className="options-header">
            <span className="options-title"></span>
            <button onClick={handleSelectAll} className="selectall-btn">
              {selectedFilters.length === orderTypes.length
                ? "Unselect all"
                : "Select all"}
            </button>
          </div>

          <div className="options-list">
            {orderTypes.map((type) => {
              const mappedValue = orderTypeMap[type];
              return (
                <button
                  key={type}
                  onClick={() => handleSelect(type)}
                  className={`option-item ${
                    selectedFilters.includes(mappedValue) ? "active" : ""
                  }`}
                >
                  {type}
                </button>
              );
            })}
          </div>

          {/* Apply Button */}
          <button onClick={handleApply} className="apply-btn">
            {t("Apply")}
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownFilter;
